<template>
    <div class="container">
        <section class="section">
            <div class="row no-gutters">
                <div class="d-none d-lg-block col-lg-6">
                    <img class="img-login-signup"
                         src="@/assets/img/stablecoins-texture.jpg"
                         alt="stablecoin"
                         style="top: var(--header-height--lg); width: 45%;">
                    <img class="position-absolute" src="@/assets/img/stablecoins.png"
                         alt="stablecoin" style="left: -35px;">
                </div>
                <div class="col-12 col-lg-6">
                    <div class="d-flex flex-column flex-gap-24 px-sm-6"><h2 class="u-mb-0 u-mt-2">In Airtm, you
                        hold and transact with Stablecoins.</h2><h5
                            class="u-mb-0 text--black font-weight--regular">Select stablecoins including USDC,
                        USDT and Dai on blockchains Ethereum, Stellar and Solana to directly add and withdraw
                        between your Stellar USDC balance in Airtm.</h5>
                        <div class="d-none d-sm-block">
                            <button class="btn btn--primary" type="button" data-loading="false"
                                    aria-expanded="false">Transfer with stablecoins
                            </button>
                        </div>
                        <div class="action-sheet">
                            <button class="btn btn--primary btn--block" type="button" data-loading="false"
                                    aria-expanded="false">Transfer with stablecoins
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "index",
    }
</script>

<style scoped>

</style>